(function () {
    'use strict';

    angular
        .module('skillsApp')
        .controller('ExemptionDialogController', ExemptionDialogController);

    function ExemptionDialogController(logger, $uibModalInstance, $translate, userQuality, dataService) {
        var vm = this;

        vm.userQualityId = userQuality.id;
        vm.exemptionCopy = angular.copy(userQuality.exemption);

        // set defaults
        if (userQuality.exemption && userQuality.exemption.dateOfExpiry) {
            vm.dateOfExpiry = new Date(userQuality.exemption.dateOfExpiry);
        } else {
            var now = new Date();
            vm.dateOfExpiry = now.setMonth(now.getMonth() + userQuality.validity);
        }

        vm.previousDateOfExpiry = vm.dateOfExpiry;
        vm.description = userQuality.exemption && userQuality.exemption.description ? userQuality.exemption.description : '';
        
        vm.datepickerIsOpen = false;
        vm.files = [];

        vm.datepickerOptions = {
            showWeeks: true
        };

        vm.addFiles = addFiles;
        vm.cancel = cancel;
        vm.dateChange = dateChange;
        vm.openDatepicker = openDatepicker;
        vm.removeFileFromTheList = removeFileFromTheList;
        vm.save = save;

        function addFiles(selectedFiles) {
            if (typeof selectedFiles !== 'object') return;

            var all_files = vm.files.slice();

            for (var prop in selectedFiles) {
                var file = selectedFiles[prop];
                if (typeof file === 'object') all_files.push(file);
            }

            var totalSize = all_files.map(function (f) { return f.size; }).reduce(function (a, b) { return a + b; });
            var maxSize = 5;

            if (totalSize > (1048576 * maxSize)) {
                return logger.error($translate.instant('the_total_files_size_may_not_exceed') + ' ' + maxSize + 'MB');
            }
            
            vm.files = all_files;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function dateChange() {
            if (vm.dateOfExpiry) {
                vm.previousDateOfExpiry = vm.dateOfExpiry;
            } else {
                vm.dateOfExpiry = vm.previousDateOfExpiry;
            }
        }

        function getFilesToRemove(oldFiles, newFiles) {
            if (oldFiles.length === newFiles.length) return null;

            var filesToRemove = [];

            for (var i = 0; i < oldFiles.length; i++) {
                var name = oldFiles[i].name;
                var filtered = _.findWhere(newFiles, { name: name });
                
                if (!filtered) {
                    filesToRemove.push(name);
                }
            }

            return filesToRemove;
        }



        function openDatepicker() {
            if (vm.datepickerIsOpen) return;
            vm.datepickerIsOpen = true;
        }

        function removeFileFromTheList(fileName) {
            vm.files = vm.files.filter(function (f) {
                return f.name !== fileName;
            });
        }

        function save() {
            var originalAssets = vm.exemptionCopy == null ? [] : vm.exemptionCopy.exemptionAssets;
            var newAssets = userQuality.exemption == null ? [] : userQuality.exemption.exemptionAssets;
            var filesToRemove = getFilesToRemove(newAssets, originalAssets);
            
            return dataService
                .saveExemption(userQuality.id, vm.dateOfExpiry, vm.description, filesToRemove, vm.files)
                .then(result => {
                    logger.success('successfully_saved');
                    $uibModalInstance.close(result);
                });
        }
    }
})();
